import React from "react";
import styles from "./Section9.module.scss";

export const Section9 = function () {
  return (
    <section className={`${styles.container} cc--component-container`} id="partnership">
      <div className={styles.content}>
        <h2 className={styles.headline}>A Powerful Educational Partnership</h2>
        <div className={styles.logos}>
          <img
            className={styles.school_logo}
            src="https://media.bootcampcdn.com/Columbia/logos/Columbia_White.svg"
            alt=""
          />
          <div className={styles.plus}></div>
          <img
            className={styles.brand_entity_logo}
            src="https://usa.bootcampcdn.com/wp-content/themes/CodingBootcamp/media/img/edx-white-registered.svg"
            alt=""
          />
        </div>
        <div className={styles.copy}>
          <h3>About Columbia Engineering</h3>
          <span>
            The mission of The Fu Foundation School of Engineering and Applied Science is to expand knowledge and
            advance technology through research, while educating learners to become leaders informed by an engineering
            foundation. Enriched with the intellectual resources of a global university in the City of New York, we push
            disciplinary frontiers, confront complex issues, and engineer innovative solutions to address the grand
            challenges of our time. We create a collaborative environment that embraces interdisciplinary thought,
            integrated entrepreneurship, cultural awareness, and social responsibility, and advances the translation of
            ideas into practical innovations.
          </span>
          <p>This boot camp is offered through Columbia Engineering in partnership with edX.</p>
          <h3>About edX</h3>
          <span>
            edX, part of 2U Inc., works with respected universities and organizations to deliver innovative,
            skills-based training to a community of over 45 million learners around the world to support them at every
            stage of their lives and careers. edX delivers boot camps through an immersive learning experience with
            expert services and valuable resources. As of 2021, graduates have been hired by 6,700+ companies, including
            more than 62% of the Fortune 100.
          </span>
        </div>
      </div>
    </section>
  );
};
